import React, { ReactElement } from 'react';

import cs from 'classnames';
import style from './style.module.scss';
import { Typography, TypographyVariants } from '../ui/typography';

interface StepProps {
    title: string
    description: string
    children: ReactElement | ReactElement[]
    className?: string
    footer?: ReactElement
    reversed?: boolean
}

export const Step = ({
  title, description, children, className, footer, reversed,
}: StepProps): ReactElement => {
  const secondBlock = (
    <div className={style.body}>
      {children}
    </div>
  );
  return (
    <div className={cs(style.step, className)}>
      {reversed && secondBlock}
      <div className={style.container}>
        <Typography className={style.title} variant={TypographyVariants.h3}>{title}</Typography>
        <Typography className={style.description} variant={TypographyVariants.body}>{description}</Typography>
        {footer}
      </div>
      {!reversed && secondBlock}
    </div>
  );
};

Step.defaultProps = {
  className: undefined,
  footer: undefined,
  reversed: false,
};
